import React, { FC } from 'react'
import styled from 'styled-components'


const Wrapper = styled.div`
  color: ${({ theme }) => theme.maxButtonColor};
  background-color: ${({ theme }) => theme.maxButtonBackgroundColor};
  border: 1px solid ${({ theme }) => theme.maxButtonBorderColor};
  border-radius: 14px;
  padding: 5px;
  font-size: 14px;
  margin-left: 5px;

  &:hover {
    cursor: pointer;
    transition: background-color 200ms linear;
    opacity: 0.8;
  }
`

export interface Props {
  onMaxClick: () => void
}

export const MaxButton: FC<Props> = ({ onMaxClick }) => {
  return (
    <Wrapper
      onClick={() => {
        onMaxClick()
      }}
    >
      MAX
    </Wrapper>
  )
}
